import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Box, Button, Card, Typography } from "@bca/ui-library";
import styled from "styled-components";
import { layout } from "styled-system";

import { formatMoney } from "./formatMoney";
import { StoreType } from "../../redux/StoreType";
import { GET_APP_STATE } from "../../redux/slices/appSlice";

interface YourProxyBidProps {
  bidAmount: number;
  onEdit: () => void;
  onDeleteProxyBid: () => void;
}

const CardWithLayout = styled(Card)<any>`
  ${layout}
`;

const RemoveButton = styled(Button)`
  font-size: 14px;
  height: 40px;
  color: #e30613;
  &:not([disabled]):hover {
    color: #e30613;
    border-color: #e30613;
  }
  &:not([disabled]):focus {
    color: #e30613;
    border-color: #e30613;
  }
  div > svg:first-of-type {
    fill: #e30613;
  }
`;

const YourProxyBid: React.FunctionComponent<YourProxyBidProps> = ({
  bidAmount,
  onEdit,
  onDeleteProxyBid,
}) => {
  const {
    app: { isSaleInProgress },
  }: StoreType = useSelector(GET_APP_STATE, shallowEqual);

  return (
    <CardWithLayout
      width="100%"
      height="auto"
      marginX={0}
      marginY={0}
      paddingX={["28px", "30px", "30px"]}
      paddingY={7}
      maxHeight={["100%", "100%", 201]}
    >
      <Typography
        variant="h6"
        css={`
          font-weight: 700;
        `}
        mt={0}
        mb={3}
      >
        Your Proxy Bid
      </Typography>
      <Typography variant="body" color="grey-blue" mt={0} mb="18px">
        We'll bid up to your maximum on your behalf in the live auction.
      </Typography>
      <Card
        width="100%"
        height="auto"
        marginX={0}
        marginY={0}
        paddingX={6}
        paddingY={4}
        css={`
          display: flex;
          justify-content: space-between;
          background-color: #fafafa;
          box-shadow: 0 2px 10px 0 rgba(217, 217, 217, 0.5);
          border: none;
        `}
      >
        <Box>
          <Typography variant="h3" margin={0} color="#0b0b0b">
            {formatMoney(bidAmount)}
          </Typography>
        </Box>
        <Box display="flex" flexWrap="wrap" justifyContent="flex-end">
          {!isSaleInProgress && (
            <RemoveButton
              text="Remove"
              variant="tertiary"
              icon="trash-alt"
              iconWidth="16px"
              iconHeight="18px"
              paddingX={0}
              onClick={onDeleteProxyBid}
            />
          )}

          <Button
            text="Edit"
            variant="secondary"
            icon="pen"
            iconWeight="solid"
            iconHeight="18px"
            iconWidth="18px"
            iconAlignment="left"
            paddingX={4}
            paddingY={3}
            marginLeft={20}
            css={`
              height: 40px;
            `}
            onClick={onEdit}
          />
        </Box>
      </Card>
    </CardWithLayout>
  );
};

export default YourProxyBid;
